import React from "react";
import { UiInput } from "../../../components/form/UiInput";

export const OpenQuestion = (props) => {
    return (
        <>
            <div className="sb-open-quest">
                <h4>{props.label}</h4>
                <UiInput
                    placeholder={props.placeholder}
                    type="textarea" />
            </div>
        </>
    )
}